package br.com.texeratx.boardgametimeapp.core.i18n

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.staticCompositionLocalOf

val LocalStrings = staticCompositionLocalOf<Strings> { PtStrings }

@Composable
fun ProvideStrings(languageManager: LanguageManager, content: @Composable () -> Unit) {
    val strings by languageManager.strings.collectAsState()
    CompositionLocalProvider(LocalStrings provides strings) {
        content()
    }
}
